import * as p from '@clack/prompts'
import type { LoadedSchema } from '@cli-types/core-engine/schema-reader.js'
import { BARREL_SCOPE } from '@cli-constants/snapshots.js'
import { detectRenameCandidates } from '@core-engine/snapshots/rename-detector/detect-rename-candidates.js'
import { diffSchemas } from '@core-engine/snapshots/schema-diff/diff-schemas.js'
import { loadManifest } from '@core-engine/snapshots/store/load-manifest.js'
import { isStoredSchemaJson } from './is-stored-schema-json.js'

export function printSchemaDiff(scope: string, loaded: LoadedSchema, cwd: string): void {
  const manifest = loadManifest(cwd, scope)
  if (!manifest || scope === BARREL_SCOPE || !isStoredSchemaJson(manifest.schemaJson)) {
    return
  }

  const diff = diffSchemas(manifest.schemaJson, loaded.schema)
  const renameCandidates = detectRenameCandidates(diff.removed, diff.added)

  if (
    diff.added.length === 0 &&
    diff.removed.length === 0 &&
    diff.changed.length === 0 &&
    diff.customComponents.added.length === 0 &&
    diff.customComponents.removed.length === 0
  ) {
    return
  }

  const lines = [`Schema diff for ${scope}:`]
  if (diff.added.length > 0) {
    lines.push(`  + fields: ${diff.added.map((field) => field.name).join(', ')}`)
  }
  if (diff.removed.length > 0) {
    lines.push(`  - fields: ${diff.removed.map((field) => field.name).join(', ')}`)
  }
  if (diff.changed.length > 0) {
    lines.push(
      `  ~ fields: ${diff.changed.map((entry) => `${entry.before.name}:${entry.before.type}->${entry.after.type}`).join(', ')}`
    )
  }
  if (renameCandidates.length > 0) {
    lines.push(
      `  ? rename candidates: ${renameCandidates.map((entry) => `${entry.before}->${entry.after}`).join(', ')}`
    )
  }
  if (diff.customComponents.added.length > 0 || diff.customComponents.removed.length > 0) {
    lines.push(
      `  custom cells: +[${diff.customComponents.added.join(', ')}] -[${diff.customComponents.removed.join(', ')}]`
    )
  }
  p.log.message(lines.join('\n'))
}
